import { api } from "../api";

/**
 * checklistFindByIdExportResponse - Function that finds on database the selected checklist and export in a PDF/XSLX file  
 * method GET  
 * @async-function
 */
const checklistFindByIdExportResponse = async (token: string, customerId: number, selectedVehicleId: number, selectedChecklistId: number, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/checklists/${customerId}/${selectedVehicleId}/${selectedChecklistId}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default checklistFindByIdExportResponse;